import Image from "next/image";
import Link from "next/link";
import React from "react";
import { SecondaryNavigationItemProps } from "@/types/layout";
import { PricePill } from "@/components/ui-kit/PricePill";
import { useRouter } from "next-translate-routes";
import useCurrentSubscriptionInfo from "@/hooks/useCurrentSubscriptionInfo";

export const SecondaryNavItem: React.FC<SecondaryNavigationItemProps> = ({
  navigationItem,
  postId,
  openedSubNav = false,
}) => {
  const router = useRouter();
  const { getDynamicSubscriptionTitle, getDynamicSubscriptionURL } = useCurrentSubscriptionInfo(
    navigationItem.title,
    navigationItem.url
  );

  const currentRoute = () => {
    if (router.asPath === navigationItem.url) {
      return "bg-gray-100";
    }
    return;
  };

  return (
    <li>
      <Link
        href={getDynamicSubscriptionURL(postId)!}
        className={`${currentRoute()} flex items-center justify-between px-5 py-3 transition-colors ease-in-out hover:bg-gray-100 dark:hover:bg-white-25`}
      >
        <span className="font-condensed text-md font-light text-black dark:text-white">
          {getDynamicSubscriptionTitle()}
        </span>
        {navigationItem.imagePath && (
          <Image
            src={navigationItem.imagePath}
            alt={navigationItem.title}
            width={8}
            height={8}
            style={{
              width: "8px",
              height: "8px",
            }}
            className={
              openedSubNav && navigationItem.dropdownMenu
                ? "rotate-180 transition delay-75 ease-in-out"
                : "transition delay-75 ease-in-out"
            }
          />
        )}
        {navigationItem.badge_content && <PricePill title={navigationItem.badge_content} />}
      </Link>
    </li>
  );
};
